import { useContext } from 'react';
import { CarFilterContext } from './FilterContext';

const useCarFilter = () => {
    const {
        carMakes,
        carModels,
        carVariants,
        carColors,
        selectedMake,
        selectedModel,
        selectedVariant,
        selectedColor,
        handleMakeChange,
        handleModelChange,
        handleVariantChange,
        setSelectedColor,
        loading,
    } = useContext(CarFilterContext); // Use context to extract values and functions

    return {
        carMakes,
        carModels,
        carVariants,
        carColors,
        selectedMake,
        selectedModel,
        selectedVariant,
        selectedColor,
        handleMakeChange,
        handleModelChange,
        handleVariantChange,
        setSelectedColor,
        loading,
    };
};

export default useCarFilter;
